import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Customers = Loadable(lazy(() => import('./Customers')));

const usersSubscribeRoutes = [
  { path: '/dashboard/users-list', element: <Customers />, auth: authRoles.admin }
];

export default usersSubscribeRoutes;
